module.exports = __webpack_public_path__ + "static/media/icon-expert.60fd9212.svg";